import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

import * as marked from 'marked';

import {
  CallbackResult,
  CallbackResultStatus,
  dateStringFromISO8601,
  getStaffNameDisplay,
  timeStringFromISO8601
} from '../../../../../../../utils';
import { CustomInboxItem } from '../../../../../../../models/custom-inbox';
import { OrganizationConfigService } from '../../../../../../../services/organization-config/organization-config.service';
import { CustomInboxService } from '../../../../../../../services/custom-inbox/custom-inbox.service';
import { InboxService } from '../../../../../../../services/inbox/inbox.service';
import { DomSanitizer } from '@angular/platform-browser';


@Component({
  selector: 'app-view-custom-inbox-item',
  templateUrl: './view-custom-inbox-item.component.html',
  styleUrls: ['./view-custom-inbox-item.component.css']
})
export class ViewCustomInboxItemComponent implements OnInit {
  @Input() itemId: number;
  @Input() savedCallback: (result: CallbackResult) => undefined;

  public item: CustomInboxItem;
  public conditionsMetList: string[];

  public loadingItem = true;
  public loadingSubmit = false;
  public notFound = false;
  public errorMessage = '';
  public serverError: number = null;

  public readonly dateStringFromISO8601 = dateStringFromISO8601;
  public readonly timeStringFromISO8601 = timeStringFromISO8601;
  public readonly getStaffNameDisplay = getStaffNameDisplay;

  constructor(
    public activeModal: NgbActiveModal,
    public orgConfig: OrganizationConfigService,
    private customInboxService: CustomInboxService,
    private inboxService: InboxService,
    private domSanitizer: DomSanitizer
  ) {}

  ngOnInit() {
    this.loadItem();
  }

  public handleResolve() {
    this.loadingSubmit = true;

    this.errorMessage = '';

    this.customInboxService
      .resolveCustomInboxItem(this.itemId)
      .then(() => {
        this.inboxService.loadInboxCounts(true).then();

        this.savedCallback({
          text: 'Inbox item resolved successfully.',
          status: CallbackResultStatus.success
        });

        this.activeModal.close();
      })
      .catch(reason => {
        if (reason.status === 400) {
          this.errorMessage = reason.error;
        } else if (reason.status === 403) {
          this.errorMessage = 'You do not have permission to take this action.';
        } else {
          this.serverError = reason.status;
        }
      })
      .finally(() => { this.loadingSubmit = false; });
  }

  public getRenderedMarkdown(content: string) {
    return this.domSanitizer.bypassSecurityTrustHtml(
      marked.parseInline(
        content,
        {
          breaks: true
        }
      )
    );
  }

  private loadItem() {
    this.loadingItem = true;

    this.customInboxService
      .getCustomInboxItem(this.itemId)
      .then(item => {
        this.item = item;
        this.conditionsMetList = item.conditions_met.split('\n');
      })
      .catch(reason => {
        if (reason.status === 404) {
          this.notFound = true;
        } else {
          this.serverError = reason.status;
        }
      })
      .finally(() => { this.loadingItem = false; });
  }
}
